module.exports = __webpack_public_path__ + "img/35.5ce44a59.jpg";